/** Firefly expanded panel width — ~1/3 viewport (with a usable floor). */

/** Legacy nominal; sizing uses `activityDockPanelWidthPx`. */
export const ACTIVITY_DOCK_SIDE_PANEL_WIDTH_PX = 360;
export const ACTIVITY_DOCK_SIDE_PANEL_MIN_WIDTH_PX = 220;

/** Viewport-relative Firefly panel width (~1/3 of screen). */
export function activityDockPanelWidthPx(viewportW: number): number {
  if (viewportW <= 0) return ACTIVITY_DOCK_SIDE_PANEL_MIN_WIDTH_PX;
  return Math.max(ACTIVITY_DOCK_SIDE_PANEL_MIN_WIDTH_PX, Math.round(viewportW / 3));
}
